import Vue from 'vue'
import Index from './Index.vue'
import 'jquery/dist/jquery.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import '../../assets/css/font.css' //自定义字体

import qs from 'qs'
import api from '../../request/api' // 自定义全局接口

Vue.prototype.$api = api;
Vue.prototype.$qs = qs;

// bootstrap-vue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

new Vue({
    render: h => h(Index)
}).$mount('#index');
